import { useState, useEffect } from "react";

/**
 * `viewport width < breakpoint` check.
 *
 * Default: initial value is `false`, resolved to the real value by an effect
 * after first paint — safe for SSR'd layouts where guessing wrong would cause
 * a hydration mismatch.
 *
 * `{ eager: true }`: seeds the state from `window` synchronously so the FIRST
 * client paint is already correct (no open→closed flash). Use only on
 * client-only surfaces that aren't server-rendered with a divergent layout.
 */
function useIsMobile(breakpoint = 1024, options?: { eager?: boolean }) {
  const eager = options?.eager ?? false;
  const [isMobile, setIsMobile] = useState(() =>
    eager && typeof window !== "undefined"
      ? window.innerWidth < breakpoint
      : false,
  );

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
